import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS } from '../Constants/styles';
import BannerSection from '../Feature/Common/BannerSection';
import { Programs_IMG } from '../Constants/ImageConstants';

const shopBanner = {
  title: 'Shop',
  description: 'Coming Soon',
  image: Programs_IMG.kidsnadults_3Image,
};

const Shop = () => {
  return (
    <>
      <BannerSection data={shopBanner} />

      <Box
        sx={{
          minHeight: '30vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          backgroundColor: COLORS.greyBG,
          borderRadius: 2,
          p: 4,
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontFamily: "'Big Shoulders Text', sans-serif",
            textTransform: 'uppercase',
            fontWeight: 600,
            color: COLORS.accentDarkGreen,
          }}
        >
          Shop   Coming Soon
        </Typography>
      </Box>
    </>
  );
};

export default Shop;
